import React from "react";
import { useIntl } from "react-intl";

import { AsyncWithSearch } from "../../AsyncSelect";
import { useTipoPlanoSpotter } from "../../../hooks";

const URL = "/api/pipeline/usuario1/listar?tipo=PreVendedor&somenteAtivos=true";
function SelectPreVendedor(props) {
  const intl = useIntl();
  const isSpotterFull = useTipoPlanoSpotter();

  return (
    <AsyncWithSearch
      id="select-prevendedor"
      label={
        isSpotterFull
          ? intl.formatMessage({ defaultMessage: "Pré-vendedor" })
          : intl.formatMessage({ defaultMessage: "Usuário" })
      }
      url={URL}
      {...props}
    />
  );
}

export default SelectPreVendedor;
